import React, { useContext, useEffect, useState } from 'react';
import HeroSection from './hero';
import HorizontalSection from './horizontalSection/HorizontalSection';
import VideoPage from './video/VideoPage';
import SuccessPage from './success/SuccessPage';
import ChangePage from './change/ChangePage';
import BeWithUsPage from './bewithus/BeWithUsPage';
import BecomePartnerSection from './becomepartnerNew/BecomePartnerSection';
import Single from '../../layouts/single/Single/Single';
import styles from './main.module.scss';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import UserContext from '../../common/utils/getContext';
import { LangContext } from '../../common/decorators/Language';
import SliderPage2 from './slider/SliderPage2';
import LazyLoad from 'react-lazy-load';

const LandingView = () => {
    const width = useWindowDimensions(true);
    const { userToken } = useContext(UserContext);
    const { translation: translates } = useContext(LangContext);

    useEffect(() => {
        const htmlElement = document.querySelector('html');
        if (htmlElement && htmlElement.hasAttribute('data-zooming')) {
            htmlElement.removeAttribute('data-zooming');
        }
    }, []);

    const [rightScrolled, setRightScrolled] = useState(false);

    useEffect(() => {
        if (width < 1024) {
            setRightScrolled(true);
        }
    }, [width]);

    return (
        <Single smallFooter={!rightScrolled} alias='/' title={'Global Trend'} translates={translates} compStyles={styles}>
            <HeroSection isUserToken={userToken} />
            <LazyLoad>
                <SliderPage2 width={width} />
            </LazyLoad>
            {/* <DescriptionPage /> */}
            {/* <Priorities width={width} /> */}
            <HorizontalSection width={width} setRightScrolled={setRightScrolled} rightScrolled={rightScrolled} />
            {/* <HorizontalSection width={width} isUserToken={userToken} /> */}
            {rightScrolled ? (
                <>
                    <VideoPage width={width} />
                    <SuccessPage width={width} />
                    <ChangePage width={width} />
                    <BeWithUsPage />
                    <LazyLoad>
                        <BecomePartnerSection width={width} isUserToken={userToken} />
                    </LazyLoad>
                </>
            ) : null}
        </Single>
    );
};
export default LandingView;
